import React from 'react'
import Icon from '../index'

const ArrowSolidUpIcon = ({ color, size }: any) => (
  <Icon color={color} size={size}>
    <polygon points="0 16 16 16 8 8" />
  </Icon>
)

ArrowSolidUpIcon.propTypes = {
  ...Icon.propTypes,
}

export default ArrowSolidUpIcon
